export function getApiHostName() {
    if (window.location.hostname.match(/editorx\.com$/)) {
        return 'editorx.com';
    }
    return 'wix.com';
}
//# sourceMappingURL=apiHostName.js.map